export default "__VITE_ASSET__DuYXoCpU__"